// Module
var code = "<p class=\"circle\">1</p> <p>Download our mobile app.</p> ";
// Exports
export default code;